export default "__VITE_ASSET__DmN$nGiI__"